<template>
  <div class="vs-row full-height m-0">
    <div class="header-top clearfix">
      <div class="container">
        <div class="row mt-5">
          <div class="col-md-2 col-sm-5 col-12 mobile-center">
            <a href="/">
              <img
                class="img-responsive"
                src="@/assets/images/logo/nowe/logo-color.svg"
                style="max-width: 190px;"
              />
            </a>
          </div>
          <div class="col-md-5"></div>
          <div class="col-md-5 col-sm-7 col-12 text-right mobile-center">
            <a href="tel:+48800706988">
              <img
                class="img-responsive"
                src="@/assets/images/logo/numer1.jpg"
                style="max-width: 210px;"
              />
              <span>800 706 988</span>
            </a>
            <vs-button
              class="login-button"
              color="#e40712"
              type="filled"
              icon="person"
              href="/login"
              style="float: right;"
              >Zaloguj</vs-button
            >
          </div>
        </div>
        <h3 class="head-banner text-center mt-5">
          Zarejestruj swoją kartę i zacznij zbierać punkty
        </h3>
        <vs-row vs-justify="center" class="login-register-bg mt-5">
          <vs-col
            type="flex"
            vs-justify="center"
            vs-align="center"
            class="login-register-box"
            vs-lg="8"
            vs-xs="12"
          >
            <vs-alert
              v-if="errors.length"
              class="mb-3 mt-2"
              color="danger"
              :active="inputValid"
            >
              <b>W formularzu wystąpiły następujące błędy:</b>
              <ul class="common-list">
                <li
                  v-for="error in errors"
                  :key="error"
                  style="white-space: normal;"
                >
                  {{ error }}
                </li>
              </ul>
            </vs-alert>
            <form @submit="checkForm" novalidate="true">
              <vs-row>
                <vs-col
                  class="d-flex align-items-center justify-content-start justify-content-md-end"
                  type="flex"
                  vs-lg="4"
                  vs-xs="12"
                >
                  <label class="vs-input--label mb-0">Twój e-mail</label>
                </vs-col>
                <vs-col type="flex" vs-lg="8" vs-xs="12">
                  <vs-input
                    icon-after="true"
                    size="medium"
                    class="inputx w-100"
                    v-model="email"
                    type="email"
                  />
                </vs-col>
              </vs-row>
              <vs-row class="mt-4">
                <vs-col
                  class="d-flex align-items-center justify-content-start justify-content-md-end"
                  type="flex"
                  vs-lg="4"
                  vs-xs="12"
                >
                  <label class="vs-input--label mb-0">Twoje hasło</label>
                </vs-col>
                <vs-col type="flex" vs-lg="8" vs-xs="12">
                  <vs-input
                    icon-after="true"
                    size="medium"
                    class="inputx w-100"
                    type="password"
                    v-model="pwd"
                  />
                </vs-col>
              </vs-row>
              <vs-row class="mt-4">
                <vs-col
                  class="d-flex align-items-center justify-content-start justify-content-md-end"
                  type="flex"
                  vs-lg="4"
                  vs-xs="12"
                >
                  <label class="vs-input--label mb-0">Powtórz hasło</label>
                </vs-col>
                <vs-col type="flex" vs-lg="8" vs-xs="12">
                  <vs-input
                    icon-after="true"
                    size="medium"
                    class="inputx w-100"
                    type="password"
                    v-model="pwd_repeat"
                  />
                </vs-col>
              </vs-row>
              <div
                class="d-flex align-items-start justify-content-center p-1 flex-column"
              >
                <!-- <div @click="checkAll()" class="d-flex align-items-start mt-4">
                          <vs-checkbox v-model="checkicon" class="mb-4"></vs-checkbox>
                          <div class="text-muted" style="font-size:11px">Zaznacz wszystkie</div>
                        </div> -->
                <div class="d-flex align-items-start">
                  <vs-checkbox v-model="checkicon1" class="mb-4"></vs-checkbox>
                  <div class="text-muted" style="font-size:11px">
                    * Zapoznałem się z <a href="https://www.tvokazje.pl/content/58-regulamin-klubu-tvokazje"
                       target="_blank" style="color: #f39313;">regulaminem programu lojalnościowego</a> i go akceptuję.
                  </div>
                </div>
                <div class="d-flex align-items-start mb-4">
                  <div class="rodo-info-box">
                    
                      Administratorem danych osobowych jest TVO sp. z o.o. z siedzibą w Gdyni. Dane przetwarzane będą m.in. w celach uczestnictwa w programie lojalnościowym: „Klub TV Okazje” i jego realizacji. Więcej informacji o zasadach przetwarzania danych, w tym o celach i prawach dostępne jest w <a href="https://www.tvokazje.pl/polityka-prywatnosci" target="_blank" style="color: #f39313;"
                      >Polityce prywatności</a>.
                    
                    
                  </div>
                </div>
                <!-- <div class="d-flex align-items-start mb-4">
                          <vs-checkbox class="mb-4" v-model="checkicon2"></vs-checkbox>
                          <div
                            class="text-muted"
                            style="font-size:11px"
                          >Chcę otrzymywać od TVO sp. z o.o. informacje marketingowe, w tym o najnowszych promocjach za pomocą telekomunikacyjnych urządzeń końcowych na mój telefon w formie wiadomości SMS/MMS. Jestem świadomy/a, że w każdej chwili mogę wycofać zgodę.</div>
                        </div>
                        <div class="d-flex align-items-start mb-4">
                          <vs-checkbox class="mb-4" v-model="checkicon3"></vs-checkbox>
                          <div
                            class="text-muted"
                            style="font-size:11px"
                          >Chcę otrzymywać od TVO sp. z o.o. informacje marketingowe, w tym o najnowszych promocjach za pomocą telekomunikacyjnych urządzeń końcowych na mój telefon (połączenia głosowe). Jestem świadomy/a, że w każdej chwili mogę wycofać zgodę.</div>
                        </div> -->
              </div>
              <input
                class="btn-block btn btn-danger submit-button mt-3"
                type="submit"
                value="Aktywuj"
              />
            </form>
          </vs-col>
        </vs-row>
        <div class="row full-width text-center">
          <div class="col-md-12">
            <img
              class="img-responsive"
              src="@/assets/images/background/logowanie-baner.png"
              style="max-width: 100%"
            />
          </div>
        </div>
        <FooterDrop></FooterDrop>
        <div class="row full-width-footer mt-5">
          <div class="col-md-3 col-12 text-right mb-5">
            <a href="#">
              <img
                class="img-responsive"
                src="@/assets/images/logo/nowe/logo-color.svg"
                style="max-width: 190px;"
              />
            </a>
          </div>
          <div class="col-md-3 col-12 text-center mb-5">
            <p class="heading-footer">BĄDŹ NA BIEŻĄCO</p>
            <a href=""
              ><img
                class="img-responsive"
                src="@/assets/images/logo/facebook.png"
                style="max-width: 43px; margin-right: 15px;"
            /></a>
            <a href=""
              ><img
                class="img-responsive"
                src="@/assets/images/logo/youtube.png"
                style="max-width: 60px; margin-right: 15px;"
            /></a>
            <a href=""
              ><img
                class="img-responsive"
                src="@/assets/images/logo/instagram.png"
                style="max-width: 43px; margin-right: 15px;"
            /></a>
          </div>
          <div class="col-md-6 col-12 mb-5">
            <p class="heading-footer">CERTYFIKATY</p>
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/payu.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/mastercard.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/opineo.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/comodo-secure.png"
              style="max-width: 60px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/era.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/fedex.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/rzetelnafirma.png"
              style="max-width: 110px; margin-right: 2px;"
            />
          </div>
          <hr />
        </div>
        <div class="row full-width-footer-bottom mt-5 text-center">
          <div class="col-12">
            <p class="mt-4">
              &copy; 2020 TV Okazje Sp. z o.o. wszelkie prawa zastrzeżone
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import FooterDrop from "../extra-components/FooterDrop";
import logMixin from "../../mixins/logMixin";

export default {
  name: "login-register-box",
  data: () => ({
    email: "",
    pwd: "",
    checkicon: false,
    checkicon1: false,
    checkicon2: false,
    checkicon3: false,
    errors: [],
    pwd_repeat: "",
    invalid: false
  }),
  components: {
    FooterDrop
  },
  mixins: [logMixin],
  methods: {
    checkForm: function(e) {
      this.errors = [];
      if (!this.email) this.errors.push("Adres email jest wymagany");
      else if (!this.validEmail(this.email))
        this.errors.push("Wpisz prawidłowy adres email");
      if (!this.pwd) this.errors.push("Hasło jest wymagane.");
      else if (this.pwd.length < 8)
        this.errors.push("Hasło musi mieć minimum 8 znaków.");
      else if (!this.passwordRegex(this.pwd))
        this.errors.push(
          "Hasło musi mieć zawierać dużą literę, małą literę oraz cyfrę."
        );
      if (this.pwd_repeat != this.pwd || !this.pwd)
        this.errors.push("Hasła muszą być jednakowe.");
      if (!this.validChecks())
        this.errors.push("Wszystkie wymagane zgody muszą być zaakceptowane.");
      e.preventDefault();
      if (this.errors.length) {
        this.addUserLog(
          this.logTypes.FAILED_REGISTRATION_VALIDATION,
          this.$route.query.user,
          this.$route.query.card,
          {
            card_number: this.$route.query.card,
            card_id: null,
            card_status: null,
            error: this.errors,
            email: this.email
          },
          true
        );
        return true;
      } else this.register();
    },
    /* eslint-disable */
    validEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPassword: function(pwd, pwd_repeat) {
      if (!pwd || pwd.length < 8 || !this.passwordRegex(pwd)) return false;
      else if (pwd !== pwd_repeat) return false;
      return true;
    },
    validChecks: function() {
      if (!this.checkicon1) return false;
      return true;
    },
    passwordRegex: function(pwd) {
      var reg = /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))/;
      return reg.test(pwd);
    },
    checkAll() {
      if (this.checkicon == false) {
        this.checkicon1 = true;
        this.checkicon2 = true;
        this.checkicon3 = true;
      } else {
        this.checkicon1 = false;
        this.checkicon2 = false;
        this.checkicon3 = false;
      }
    },
    register() {
      let data = {
        email: this.email,
        password: this.pwd,
        password_confirmation: this.pwd_repeat,
        newsletter_agr: this.checkicon2,
        sms_agr: this.checkicon2,
        phone_agr: this.checkicon3
      };
      let card = this.$route.query.card;
      let expires = this.$route.query.expires;
      let user = this.$route.query.user;
      let signature = this.$route.query.signature;
      axios
        .post(process.env.VUE_APP_LARAVEL_ENDPOINT + "/api/register", data, {
          params: {
            card,
            expires,
            user,
            signature
          }
        })
        .then(response => {
          this.$router.push("/check-email");
        })
        .catch(error => {
          this.errors = [];
          if (error.response) {
            let code = error.response.data.code;
            if (code === "user_registered")
              this.errors.push("Konto jest już aktywowane.");
            if (error.response.data.errors.email)
              this.errors.push("Podany adres email jest już zajęty.");
            else
              this.errors.push(
                "Wystąpił nieznany błąd, spróbuj ponownie później."
              );
          } else
            this.errors.push(
              "Wystąpił nieznany błąd, spróbuj ponownie później."
            );
          this.invalid = true;
        });
    }
    /* eslint-enable */
  },
  computed: {
    inputValid() {
      if (
        this.validEmail(this.email) &&
        this.validPassword(this.pwd, this.pwd_repeat) &&
        this.validChecks() &&
        !this.invalid
      ) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
<style scoped>
.reminder {
  text-align: center;
  font-size: 13px;
  color: #6b6b6b;
  cursor: pointer;
}
.reminder:hover {
  color: #f68d28;
}
.col-md-5.col-sm-7.col-12.text-right.mobile-center > a {
  display: inline-block;
  position: relative;
}
.col-md-5.col-sm-7.col-12.text-right.mobile-center > a > span {
  position: absolute;
  left: 50px;
  top: 12px;
  font-size: 18px;
  font-weight: 800;
  color: rgb(35, 36, 56);
}
.btn-block.btn.btn-danger.submit-button.mt-3 {
  background-color: #091f44;
  border-color: #091f44;
  width: 30%;
  margin-left: auto;
  margin-right: auto;
}
.vs-input--label {
  padding-left: 5px;
  font-size: 1.1rem;
  color: rgba(0, 0, 0, 0.7);
}
p {
  font-size: 20px;
}
p.heading {
  font-size: 24px;
}
.full-width-footer-bottom p {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.3);
}
.collapse-header {
  font-size: 30px;
  font-weight: bold;
}
.vuesax-app-is-ltr .vs-collapse-item--icon-header {
  right: 22%;
}
i.vs-icon {
  font-size: 35px;
}
.second-collapse .vuesax-app-is-ltr .vs-collapse-item--icon-header {
  left: 0;
}
.heading-footer {
  font-size: 18px;
  font-weight: bold;
  color: #fa7b35;
}
.vs-button-warning.vs-button-filled:hover {
  box-shadow: none;
}
.login-button {
  margin-top: 2px;
  box-shadow: none;
}
.includeIcon {
  float: right;
}
.con-content--item {
  padding: 20px;
}
.blank_layout {
  overflow-x: hidden;
}
.full-height {
  background-color: white;
}
.head-banner {
  background-color: #fea03e;
  padding: 15px;
  color: white;
  max-width: 70%;
  margin-left: auto;
  margin-right: auto;
}
.text-muted {
  color: rgba(0, 0, 0, 0.7) !important;
}
@media screen and (min-width: 577px) {
  .full-height {
    background-color: white;
    display: grid;
    overflow-x: hidden;
    min-height: 100vh;
  }
}
@media screen and (max-width: 576px) {
  .row.mt-5 {
    margin-top: 0px !important;
    padding-top: 3rem;
  }
  .mobile-center {
    text-align: center !important;
  }
  .col-md-5.col-sm-8.col-12.text-right.mobile-center > a {
    display: none;
  }
  .login-button {
    margin: 18px auto 18px;
  }
  .includeIcon {
    float: initial;
  }
}
@media screen and (min-width: 1168px) {
  .full-width {
    margin-left: calc(-100vw / 2 + 1100px / 2);
    margin-right: calc(-100vw / 2 + 1100px / 2);
  }
  .full-width-footer {
    margin-left: calc(-100vw / 2 + 1140px / 2);
    margin-right: calc(-100vw / 2 + 1140px / 2);
  }
  .full-width-footer-bottom {
    margin-left: calc(-100vw / 2 + 1140px / 2);
    margin-right: calc(-100vw / 2 + 1140px / 2);
    border-top: 1px solid rgba(0, 0, 0, 0.04);
  }
}

@media screen and (max-width: 768px) {
  .row.full-width-footer.mt-5 > .col-md-3.col-12.text-right,
  .row.full-width-footer.mt-5 > .col-md-6.col-12.mb-5 {
    text-align: center !important;
  }
}

.rodo-info-box {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.7);
  border: 1px solid #acaaa6;
  padding: .5rem 1rem;
  overflow: auto;
  font-size: 11px;
}
</style>
